import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import type NavigationMenu from "../../navigation.model";

@Component({
    selector: 'app-navigation-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GroupComponent {

  readonly item = input<NavigationMenu>(undefined);

}
